import { Dispatch } from "redux"
import { toast } from "react-toastify"
import { setHelpDocuments } from "./reducer"

// GET /sync-log/:moduleName
export const getHelpDocuments = () => async (dispatch: Dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/help-document`

    const res = await fetch(url, {
      credentials: "include",
      method: "GET",
    })

    if (!res.ok) {
      const errBody = await res.json()
      throw new Error(errBody.message)
    }

    const data = await res.json()
    dispatch(setHelpDocuments(data.data))
    return data.data

  } catch (err: any) {
    toast.error(err.message ?? "Error getting most recent sync log")
    return null

  }
}